import React, { useMemo } from 'react';
import {Button, Card, Icon, Label, List, Modal, Table} from 'semantic-ui-react'

interface ComponentProps {
    statusTitle: string
    getMonthlyData: (type: string) => void
    handleStatusMenuClick: () => void
    reportData: any
    reportType: string
    statuses: any
    totals: any
}

export default function ReferralStatusOptions(props: ComponentProps) {
    const { statusTitle, statuses, reportData, reportType, totals: monthlyTotals, handleStatusMenuClick, getMonthlyData } = props;
    const { stats, statusCounts, notStartedTotal } = useMemo(() => {
        const componentType = statusTitle.split(' ')[0].toLowerCase();
        const componentStats = Object.values(statuses).filter((status: any) => status.type === componentType);

        const referrals: any[] = Object.values(reportData).flatMap((dayData: any) => Object.values(dayData).flat());

        const statusMap = new Map(componentStats.map((s: any) => [s.id, s.referStatus]));

        const uniquePatientStatuses: any[] = Array.from(
            referrals.reduce((acc, ref: any) => {
                const statusName = (ref.refInPractice === null && ref.statusId === null) ? 'Not Started' : statusMap.get(ref.statusId);
                if (statusName && ref.speciality === componentType) {
                    acc.set(ref.patientId, statusName);
                }
                return acc;
            }, new Map()).values()
        );

        const calculatedStatusCounts: { [key: string]: number } = uniquePatientStatuses.reduce((acc: { [key: string]: number }, statusName: string) => {
            acc[statusName] = (acc[statusName] || 0) + 1;
            return acc;
        }, {});

        const totalWithStatus = Object.entries(calculatedStatusCounts).reduce((sum, [name, count]) => name !== 'Not Started' ? sum + count : sum, 0);
        const calculatedNotStartedTotal = Math.max(0, (monthlyTotals[reportType] || 0) - totalWithStatus);

        return { type: componentType, stats: componentStats, statusCounts: calculatedStatusCounts, notStartedTotal: calculatedNotStartedTotal };
    }, [statusTitle, statuses, reportData, reportType, monthlyTotals]);

    const onViewAll = () => {
        handleStatusMenuClick();
        getMonthlyData(reportType);
    }

    return (
        <div style={{width: '350px'}}>
            <h3 className="mt10 mb5">{statusTitle}</h3>
            <Table striped={true} compact={true}>
                <Table.Body>
                    {
                        stats?.map((item: any, key: any) => {
                            const count = item.referStatus.toLowerCase() === "not started" ? notStartedTotal : statusCounts[item.referStatus] || 0;
                            return <Table.Row key={key}>
                                <Table.Cell>{item.referStatus}</Table.Cell>
                                <Table.Cell><Label content={count} style={{background: item.statusColor, color: 'white'}}/></Table.Cell>
                            </Table.Row>
                        })
                    }
                </Table.Body>
            </Table>
            <br/>
            <Button primary={true} content="Open Details" onClick={onViewAll}/>
        </div>
    )
}
